import { render, staticRenderFns } from "./EmergencyResume.vue?vue&type=template&id=00daa15c&scoped=true"
import script from "./EmergencyResume.vue?vue&type=script&lang=js"
export * from "./EmergencyResume.vue?vue&type=script&lang=js"
import style0 from "./EmergencyResume.vue?vue&type=style&index=0&id=00daa15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daa15c",
  null
  
)

export default component.exports